export enum AssessmentType {
  TFM = 'TFM',
  BDD = 'BDD',
  PHQ = 'PHQ',
  CHRT = 'CHRT',
  TLFB_OTHER_SUBSTANCES = 'TLFB-OTHER-SUBSTANCES',
  TLFB_ALCOHOL = 'TLFB-ALCOHOL',
  CGSQ = 'CGSQ',
  PARENTING_TASK = 'PARENTING-TASK',
  DERS_SUBSCALES = 'DERS-SUBSCALES',
  BEST_SUBSCALES = 'BEST-SUBSCALES',
}
